import PlanFileData from "@/pages/takeoff/context/project-measure/models/plan-file-data";
import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action";

const filePlanReducer: (draft: PlanFileData, action: ProjectFilePlanReducerAction) => void = (draft, action) => {
    switch (action.type) {
        case 'hydrate':
            draft.hydrate(action.payload.origin, action.payload.origins, action.payload.content);
            break;

        case 'change-content-type':
            draft.setContentType(action.contentType);
            draft.setDirtyFlag(true);
            break;
        case 'change-origin':
            draft.setOrigin(action.origin.id);
            draft.setDirtyFlag(true);
            break;
            
        case 'change-scale-from-measure':
            draft.setUserMeasuredScale(action.newScale);
            draft.setDirtyFlag(true);
            break;
        case 'change-segment':
            draft.setUserMeasuredSegment(action.segment);
            draft.setDirtyFlag(true);
            break;
            
        case 'change-format':
            draft.setFormat(action.format);
            draft.setDirtyFlag(true);
            break;
        case 'change-scale':
            draft.setScale(action.scale);
            draft.setDirtyFlag(true);
            break;
        case 'change-orientation':
            draft.setOrientation(action.orientation);
            draft.setDirtyFlag(true);
            break;

        case 'set-dirty-flag':
            draft.setDirtyFlag(action.isDirty);
            break;
        default:
            throw new Error('Unknown action type');
    }
}

export default filePlanReducer;